import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { NavBar } from './NavBar';
import { TopBar } from './TopBar';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    padding: theme.spacing(2)
  },
  bottomNav: {
    flexGrow: 1,
    width: '100%',
    position: 'fixed',
    bottom: 0,
  },
}));

export const DashboardLayout = ({ children, user, currentRouteTitle }: any) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar currentRouteTitle={currentRouteTitle} onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        user={user}
        onMobileClose={() => setMobileNavOpen(false)}
        onMobileOpen={() => setMobileNavOpen(true)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Hidden mdDown>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography color="textPrimary">
                  <Link color="inherit" to="/dashboard">
                    Home
                                </Link>
                </Typography>
                <Typography color="textPrimary">
                  {currentRouteTitle}
                </Typography>
              </Breadcrumbs>
            </Hidden>
            {children}
          </div>
          {/* <Hidden lgUp>
                        <BottomNavigation
                            // value={selectedTab}
                            // onChange={(event, tab) => setSelectedTab(tab)}
                            showLabels
                            className={classes.bottomNav}
                        >
                            <BottomNavigationAction label="Dashboard" icon={<FontAwesomeIcon icon={faChartLine} />} />
                            <BottomNavigationAction label="Estoque" icon={<FontAwesomeIcon icon={faBalanceScale} />} />
                            <BottomNavigationAction label="Caixas" icon={<FontAwesomeIcon icon={faShoppingCart} />} />
                            <BottomNavigationAction label="Automação" icon={<FontAwesomeIcon icon={faDollarSign} />} />

                        </BottomNavigation>
                    </Hidden> */}
        </div>
      </div>
    </div >
  );
};
